import { render, staticRenderFns } from "./magicPlace.vue?vue&type=template&id=29e50116&"
import script from "./magicPlace.vue?vue&type=script&lang=js&"
export * from "./magicPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports